export const FXS_EMAIL_DOMAIN = '@fxstreet.com';
